module.exports = __webpack_public_path__ + "static/img/menu_info.49756ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconMenu/menu_info.png
// module id = u78F
// module chunks = 2